import { useAppTranslation } from "@hooks/useAppTranslation";
import AlloweatLayout from "@/packages/auth/AlloweatLayout/AlloweatLayout";
import "./ServiceWorks.scss";

const ServiceWorks = () => {
  const { t } = useAppTranslation();
  const IMG_LINK = "/static/serviceWorks/gearAndPacman.png";

  return (
    <AlloweatLayout>
      <div className="service-works">
        <div className="d-flex-column d-align-center d-gap-24 d-pa-24 d-border-radius-12 d-bg-white service-works__card">
          <div className="d-flex-column d-gap-24">
            <div className="d-flex d-justify-center d-align-center">
              <img
                src={IMG_LINK}
                width={111}
                height={111}
                alt={t("empty_states.alt.service_works")}
              />
            </div>

            <div className="d-flex-column d-gap-12 d-service-works-text">
              <span className="service-works__title d-h5">
                {t("empty_states.service_works.title")}
              </span>
              <span className="service-works__text d-paragraph-m-medium">
                {t("empty_states.service_works.description")}
              </span>
            </div>
          </div>

          <div className="service-works__pink-box d-flex d-justify-center d-align-center d-border-radius-8 d-pa-16 d-width-100">
            <span className="service-works__box-text d-paragraph-s-semibold d-text-header">
              {t("empty_states.service_works.window")}
            </span>
          </div>
        </div>
      </div>
    </AlloweatLayout>
  );
};

export default ServiceWorks;
